import {
    FC,
    FormEvent,
    ReactElement,
    useRef,
} from 'react';

import { FormActionButtons, Notice } from '../../../compositions';
import trans from '../../../helpers/trans';
import { Counselor } from '../../../models/Counselor/Counselor';
import { DialogFormProps, NoticeType } from '../../../types';

import './ArchiveCounselorForm.scss';

interface ArchiveCounselorFormProps extends DialogFormProps<Counselor> {
    hasActiveCandidates: boolean;
    counselor?: Counselor;
    className?: string;
}

const ArchiveCounselorForm: FC<ArchiveCounselorFormProps> = ({
    isLoading,
    hasActiveCandidates,
    error,
    counselor,
    onSubmit,
    onCancel,
    className = '',
}): ReactElement => {
    const formRef = useRef<HTMLFormElement>(null);

    const handleSubmit = (event: FormEvent<HTMLFormElement>): void => {
        event.preventDefault();

        if (!counselor) return;

        onSubmit(counselor);
    };

    return (
        <form ref={formRef} onSubmit={handleSubmit} className={`archive-counselor-form ${className}`}>
            <p className="archive-counselor-form__description">
                {trans('forms.archiveCounselor.description', {
                    fullName: counselor?.fullName || '',
                })}
            </p>

            {error && (
                <Notice
                    type={NoticeType.error}
                    text={error}
                    className="archive-counselor-form__notice"
                />
            )}

            {hasActiveCandidates && (
                <Notice
                    type={NoticeType.warning}
                    text={trans('forms.archiveCounselor.hasActiveCandidatesNotice')}
                    className="archive-counselor-form__notice"
                />
            )}

            <FormActionButtons
                isLoading={isLoading}
                disabled={!!error || hasActiveCandidates}
                submitIcon="arrow-right"
                submitText={trans('forms.archiveCounselor.submitButtonLabel')}
                onCancelClick={onCancel}
                className="archive-counselor-form__action-buttons"
            />
        </form>
    );
};

export default ArchiveCounselorForm;
